import { render, staticRenderFns } from "./weekDay.vue?vue&type=template&id=4dda5c1e"
import script from "./weekDay.vue?vue&type=script&lang=js"
export * from "./weekDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports